module.exports = __webpack_public_path__ + "img/cxTrends-12.1a90a88c.png";